import CustomErrorBoundary from "../ErrorPage/ErrorBoundary";
import { FormSectionTitle } from "styles/formStyleComponents";
import {
  TextField,
  PasswordField,
  PhoneField,
  NumberField,
  SingleSelectField,
  MultiSelectField,
  // TagDropdownField,
  // TagArrayField,
  // WidgetTypeSelectorField,
  // YAxisModeField,
  // IconSelectorField,
  IconBackgroundSelectorField,
  CheckboxField,
  CheckboxGroupField,
  InterpretationField,
  DatePickerField,
  CustomField,
  UnknownFieldType,
} from "./FieldTypes";

const GenericFormField = ({ 
  field,  
  value,
  allValues = {},
  onChange,
  onFieldBlur,
  error,
  errors = {},
  name: directName,
  label: directLabel,
  placeholder: directPlaceholder,
  type: directType,
  required: directRequired,
  info: directInfo,
  options: directOptions,
  maxItems: directMaxItems,
  minItems: directMinItems,
  itemLabels: directItemLabels,
  disabled: directDisabled,
  customRender: directCustomRender,
  validation: directValidation,
  onOpen: directOnOpen,
  onClose: directOnClose,
  inputProps: directInputProps,
  inputType: directInputType,
}) => {
  const {
    name = directName,
    label = directLabel,
    placeholder = directPlaceholder,
    type = directType,
    required = directRequired ?? false,
    info = directInfo,
    options = directOptions ?? [],
    maxItems = directMaxItems ?? 4,
    minItems = directMinItems,
    itemLabels = directItemLabels ?? [],
    disabled = directDisabled ?? false,
    customRender = directCustomRender,
    validation = directValidation ?? {},
    onOpen = directOnOpen,
    onClose = directOnClose,
    inputProps = directInputProps ?? {},
    inputType = directInputType,
    allowArbitraryDeletion = false,
    showLabelInput = false,
    compact = false,
    hideLabel = false,
    inline = false,
    minDate,
    maxDate,
    format,
    popperProps,
    allowOrdering = false,
    isTagInterpretation = false,
    interpretationConfig = null,
    customTagCard = null,
    isUnitApplicable = false,
    isMLTagApplicable = false,
    mlTagLabel = "Forecast Tag Name",
    mlTagPlaceholder = "Select Forecast Tag.....",
    measuredTagLabel,
    valueDisplay,
    disableClearable = false,
    emptyLabel,
    menuTitle,
    roleLabelMap,
    stopClickPropagation = false,
    ariaLabel,
    hint,
    hintId,
    multiple,
    loading,
    loadingText,
    filterOptions,
  } = field || {};

  const fieldProps = {
    name,
    label,
    placeholder,
    value,
    required,
    disabled,
    error,
    errors,
    info,
    options,
    maxItems,
    minItems,
    itemLabels,
    validation,
    onOpen,
    onClose,
    customRender,
    field,
    allValues,
    onChange,
    onFieldBlur,
    allowArbitraryDeletion,
    showLabelInput,
    compact,
    hideLabel,
    inline,
    minDate,
    maxDate,
    format,
    popperProps,
    allowOrdering,
    isTagInterpretation,
    interpretationConfig,
    customTagCard,
    isUnitApplicable,
    isMLTagApplicable,
    mlTagLabel,
    mlTagPlaceholder,
    measuredTagLabel,
    valueDisplay,
    disableClearable,
    emptyLabel,
    menuTitle,
    roleLabelMap,
    stopClickPropagation,
    ariaLabel,
    hint,
    hintId,
    multiple,
    loading,
    loadingText,
    filterOptions,
    inputProps,
    inputType,
    field,
  };

  const renderField = () => {
    switch (type) {
      case "text":
        return <TextField {...fieldProps} />;

      case "password":
        return <PasswordField {...fieldProps} />;

      case "phone":
        return <PhoneField {...fieldProps} />;
      
      case "number":
        return <NumberField {...fieldProps} />;
      
      case "singleSelect":
        return <SingleSelectField {...fieldProps} />;
      
      case "multiSelect":
        return <MultiSelectField {...fieldProps} />;
      
      // case "tagDropdown":
      //   return <TagDropdownField {...fieldProps} />;
      
      // case "tagArray": {
      //   const forecastEnabled = !!allValues?.isForecastEnabled;
      //   return (
      //     <TagArrayField
      //       {...fieldProps}
      //       isForecastEnabled={forecastEnabled}
      //       isMLTagApplicable={isMLTagApplicable && forecastEnabled}
      //     />
      //   );
      // }
      
      // case "widgetTypeSelector":
      //   return <WidgetTypeSelectorField {...fieldProps} />;
      
      // case "yAxisMode":
      //   return <YAxisModeField {...fieldProps} errors={errors} />;
      
      // case "iconSelector":
      //   return <IconSelectorField {...fieldProps} />;
      
      case "iconBackgroundSelector":
        return <IconBackgroundSelectorField {...fieldProps} />;
      
      // case "alarmCheckboxSelector":
      //   return <AlarmCheckboxSelectorField {...fieldProps} />;
      
      case "checkbox":
        return <CheckboxField {...fieldProps} />;

      case "checkboxGroup":
        return <CheckboxGroupField {...fieldProps} />;
      
      case "interpretation":
        return <InterpretationField {...fieldProps} />;
      
      case "datePicker":
        return <DatePickerField {...fieldProps} />;

      // case "filterCard":
      //   return <FilterCardField {...fieldProps} />;

      // case "alarmTypeSelector":
      //   return <AlarmTypeSelectorField {...fieldProps} />;

      case "sectionTitle":
        return <FormSectionTitle>{label}</FormSectionTitle>;

      case "custom":
        if (customRender) {
          return <CustomField {...fieldProps} />;
        }
        return <UnknownFieldType type={type} />;
      
      default:
        return <UnknownFieldType type={type} />;
    }
  };

  return (
    <CustomErrorBoundary error={`Error in ${type} field: ${name || label}`}>
      {renderField()}
    </CustomErrorBoundary>
  );
};

export default GenericFormField;
 